/* src/app/components/discovery/bates-range-select/bates-range-select.component.scss */
.main-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: nowrap;
}
.cell {
  width: 33%;
}
.mat-mdc-row:hover {
  background-color: #eeeeee;
}
.click-row {
  cursor: pointer;
}
.info-text {
  color: rgba(0, 0, 0, 0.54);
}
.expander-icon-color {
  color: rgba(0, 0, 0, 0.54);
}
:host-context(.dark-theme) .expander-icon-color {
  color: rgba(255, 255, 255, 0.6);
}
:host-context(.dark-theme) .main-container .mat-expansion-panel,
:host-context(.dark-theme) .main-container .mat-mdc-table {
  background: #3f3f3f;
}
:host-context(.dark-theme) .mat-mdc-row:hover {
  background-color: transparent;
  background: rgba(255, 255, 255, 0.06);
}
/*# sourceMappingURL=bates-range-select.component.css.map */
